import React from "react";
import { useTranslation } from "react-i18next";

import { Link } from "react-router-dom";
import classnames from "classnames";
import { Transfer } from "../../types";

import styles from "./ResponsibleFor.module.scss";

export interface Props {
  transfer: Transfer;
  isStaffView: boolean;
}

const ResponsibleFor = ({ transfer, isStaffView }: Props) => {
  const { t } = useTranslation();
  const { createdBy, companyCreator } = transfer;

  return isStaffView ? (
    <div className={classnames(styles.participantInfo)}>
      <div className={styles.roleInfo}>
        <span>
          {`${t(`businessRoles.${companyCreator?.businessRoleCode}`)} · `}
        </span>
        <Link to={`/participants/${companyCreator?.companyId}`}>
          {`#${companyCreator?.regNumber}`}
        </Link>
      </div>
      <div className={styles.responsibleInfo}>
        <span>{companyCreator?.displayName}</span>
        <span>
          {`${t("transfers.details.responsibleFor.by")} `}
          <span>{createdBy}</span>
        </span>
      </div>
    </div>
  ) : (
    <div className={styles.dateItem}>
      <span>{t("transfers.details.responsibleFor.createdBy")}</span>
      <span className={styles.dateLine}>{createdBy}</span>
    </div>
  );
};

export default ResponsibleFor;
